export const AIR_AMBULANCE_CANCEL_ERROR_NOTIFICATION =
  'Cancellation Request Failed – Please Contact Air Service via Telephone';

export const AIR_AMBULANCE_REASON_NO_EXT_TRIP_ID = 'No ext_trip_id found';

export const AIR_AMBULANCE_CANCEL_FAILED_LOG =
  'Air Ambulance cancel request failed';
